import _flatten from 'lodash/flatten';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';
import { getLocalData } from 'utils/localDataStore';

export const getFiltersFromProfile = ({
  profile,
  insuranceOptions,
  audienceTagsRelations,
  profileConfig,
  insuranceLabel,
  locale,
}) => {
  if (profile.isEmpty) {
    const insuranceTags = getDataFromInsurance(
      insuranceOptions,
      {
        insurance: getLocalData('insurance') || [],
      },
      audienceTagsRelations,
      insuranceLabel,
    );

    return {
      audiences: [],
      tags: [],
      insuranceTags,
      excludedAudiences: [],
      excludedTags: [],
    };
  }

  const audiences = getDataFromProfile(
    'audience',
    profileConfig,
    profile,
    locale,
  );
  const tags = getDataFromProfile('tag', profileConfig, profile, locale);
  const insuranceTags = getDataFromInsurance(
    insuranceOptions,
    profile,
    audienceTagsRelations,
    insuranceLabel,
  );

  const excludedAudiences = getExclusionDataFromProfile(
    audiences,
    audienceTagsRelations,
  );
  const excludedTags = getExclusionDataFromProfile(tags, audienceTagsRelations);

  return {
    audiences,
    tags,
    insuranceTags,
    excludedAudiences,
    excludedTags,
  };
};

const getDataFromProfile = (type, config, profile, locale) => {
  const data = [];

  Object.keys(_get(config, type, {})).forEach(key => {
    const value = profile[key];
    if (
      Array.isArray(value) &&
      _some(value, item =>
        Object.keys(_get(config, [key, 'items'], {})).includes(item),
      )
    ) {
      value.forEach(item => {
        if (Object.keys(_get(config, [type, key, 'items'], {})).includes(item))
          data.push({
            label: _get(config, [type, key, 'label', locale], '').replace(
              '<value>',
              _get(config, [type, key, 'items', item, locale]),
            ),
            value: _get(config, [type, key, 'items', item, locale]),
          });
      });
    } else if (
      Object.keys(_get(config, [type, key, 'items'], {})).includes(value)
    )
      data.push({
        label: _get(config, [type, key, 'label', locale], '').replace(
          '<value>',
          _get(config, [type, key, 'items', value, locale]),
        ),
        value: _get(config, [type, key, 'items', value, locale]),
      });
  });

  return data;
};

const getDataFromInsurance = (options, profile, relations, insuranceLabel) => {
  const data = [];

  const parsedRelations = Object.keys(relations).map(key => relations[key]);

  const matchedOptions = options.filter(item =>
    _get(profile, 'insurance', []).includes(item.value),
  );

  if (insuranceLabel) {
    matchedOptions.forEach(option => {
      const [relation] = parsedRelations.filter(item =>
        option.tags.includes(item.id),
      );
      if (relation) {
        data.push({
          label: insuranceLabel.replace('<value>', relation.title),
          value: relation.title,
          id: relation.id,
        });
      }
    });
  }

  return data;
};

export const getProfileFiltersFromAnswers = (
  audiences,
  tags,
  audienceTagsRelations,
) => {
  const excludedAudiences = getExclusionDataFromProfile(
    audiences,
    audienceTagsRelations,
  );
  const excludedTags = getExclusionDataFromProfile(tags, audienceTagsRelations);

  return { audiences, tags, excludedAudiences, excludedTags };
};

const getExclusionDataFromProfile = (data, relations) => {
  const exclusionData = _flatten(
    data
      .map(item => _get(relations, [item.value, 'exclude']))
      .filter(item => !_isEmpty(item)),
  )
    .filter(item => !data.map(el => el.value).includes(item.name))
    .map(item => item.name);

  return exclusionData;
};
